// Loads images and videos ahead of the scroll so nothing waits to appear: once the page is ready,
// the pictures still marked lazy are fetched a few at a time, nearest to the visitor first.
(() => {
  'use strict';
  const saver = navigator.connection && navigator.connection.saveData;
  if (saver) return;
  const idle = window.requestIdleCallback || (fn => setTimeout(fn, 200));
  const BATCH = 8;

  const queue = () => {
    const top = window.scrollY;
    return [...document.querySelectorAll('img[loading="lazy"]')]
      .filter(img => !img.complete && !img.closest('[hidden]'))
      .sort((a, b) => Math.abs(a.getBoundingClientRect().top + top - top) - Math.abs(b.getBoundingClientRect().top + top - top));
  };
  const next = pending => {
    if (!pending.length) return;
    const batch = pending.splice(0, BATCH);
    let left = batch.length;
    const done = () => { if (--left === 0) setTimeout(() => next(pending), 0); };
    batch.forEach(img => {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      img.loading = 'eager';
    });
  };
  const start = () => {
    // Videos further down get their first frames ready too
    document.querySelectorAll('video[preload="none"]').forEach(video => { video.preload = 'metadata'; });
    idle(() => next(queue()));
  };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
})();